'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isNodeSide = isNodeSide;
exports.isNative = isNative;
exports.isDev = isDev;
exports.isRenderLog = isRenderLog;
exports.isRenderTry = isRenderTry;

var _url = require('./url');

/**
 * Judge whether the environment is Node.js
 * @return {boolean}
 */
function isNodeSide() {
  return typeof process !== 'undefined';
}

function isNative() {
  var Ali = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return typeof Ali !== 'undefined' && (Ali.isDingDing || Ali.isAliwork || Ali.isCloundMail);
}

function isDev() {
  return !!(0, _url.parseQuery)().dev;
}

function isRenderLog() {
  return (0, _url.parseQuery)().debug !== undefined;
}

function isRenderTry() {
  return (0, _url.parseQuery)().debug === 'preRender';
}